import "./TermsAndConditions.css";

const TermsAndConditions = () => (
  <main className="legal-page">
    <div className="container">
      <h1>Terms and Conditions</h1>
      <p>Last Updated: June 2026</p>
      <p>Welcome to Trainosys Singapore (“Trainosys”, “we”, “our”, or “us”).</p>
      <p>By accessing or using <a href="https://trainosys.sg" target="_blank" rel="noreferrer">https://trainosys.sg</a>, you agree to comply with these Terms and Conditions.</p>
      <h2>1. Training Services</h2>
      <p>Trainosys provides professional training services including IT, artificial intelligence, cybersecurity, data analytics, business intelligence, cloud computing, programming, and related professional education.</p>
      <h2>2. Course Registration</h2>
      <p>Course registration is subject to confirmation and availability.</p>
      <p>Trainosys reserves the right to:</p>
      <ul><li>Adjust schedules</li><li>Modify instructors</li><li>Update training content</li><li>Cancel sessions when necessary</li></ul>
      <h2>3. Payments and Refunds</h2>
      <p>Applicable fees and refund conditions shall be communicated before enrollment.</p>
      <p>Refund requests may be subject to administrative review.</p>
      <h2>4. Intellectual Property</h2>
      <p>All training materials, content, branding, website assets, and documentation remain the property of Trainosys unless otherwise stated.</p>
      <p>Reproduction or redistribution is prohibited without written permission.</p>
      <h2>5. Website Usage</h2>
      <p>Users agree not to:</p>
      <ul><li>Misuse website functionality</li><li>Attempt unauthorized access</li><li>Submit false information</li></ul>
      <h2>6. Limitation of Liability</h2>
      <p>Trainosys isn't responsible for indirect or incidental damages arising from use of the website or training services.</p>
      <h2>7. External Services</h2>
      <p>Our website may integrate third-party services including analytics, communications platforms, and external links.</p>
      <h2>8. Updates</h2>
      <p>Trainosys reserves the right to update these Terms at any time.</p>
      <h2>9. Contact</h2>
      <p>Website:<br /><a href="https://trainosys.sg" target="_blank" rel="noreferrer">https://trainosys.sg</a></p>
      <p>Email:<br /><a href={`mailto:${["inquiry", "@", "trainosys.com"].join("")}`}>inquiry@trainosys.com</a></p>
    </div>
  </main>
);

export default TermsAndConditions;
